"use strict";

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

var __generator = this && this.__generator || function (thisArg, body) {
  var _ = {
    label: 0,
    sent: function sent() {
      if (t[0] & 1) throw t[1];
      return t[1];
    },
    trys: [],
    ops: []
  },
      f,
      y,
      t,
      g;
  return g = {
    next: verb(0),
    "throw": verb(1),
    "return": verb(2)
  }, typeof Symbol === "function" && (g[Symbol.iterator] = function () {
    return this;
  }), g;

  function verb(n) {
    return function (v) {
      return step([n, v]);
    };
  }

  function step(op) {
    if (f) throw new TypeError("Generator is already executing.");

    while (_) {
      try {
        if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
        if (y = 0, t) op = [op[0] & 2, t.value];

        switch (op[0]) {
          case 0:
          case 1:
            t = op;
            break;

          case 4:
            _.label++;
            return {
              value: op[1],
              done: false
            };

          case 5:
            _.label++;
            y = op[1];
            op = [0];
            continue;

          case 7:
            op = _.ops.pop();

            _.trys.pop();

            continue;

          default:
            if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
              _ = 0;
              continue;
            }

            if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
              _.label = op[1];
              break;
            }

            if (op[0] === 6 && _.label < t[1]) {
              _.label = t[1];
              t = op;
              break;
            }

            if (t && _.label < t[2]) {
              _.label = t[2];

              _.ops.push(op);

              break;
            }

            if (t[2]) _.ops.pop();

            _.trys.pop();

            continue;
        }

        op = body.call(thisArg, _);
      } catch (e) {
        op = [6, e];
        y = 0;
      } finally {
        f = t = 0;
      }
    }

    if (op[0] & 5) throw op[1];
    return {
      value: op[0] ? op[1] : void 0,
      done: true
    };
  }
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RndApi = void 0;

var axios_1 = require("axios");

var headers = {
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json'
  }
};

var RndApi = function () {
  function RndApi(baseUrl, token) {
    var _this = this;

    this.get = function (endpoint, params) {
      return __awaiter(_this, void 0, void 0, function () {
        var url;
        return __generator(this, function (_a) {
          url = this.baseUrl + endpoint;
          return [2
          /*return*/
          , axios_1.default.get(url + ("?api_token=" + this.token + (params || '')), headers)];
        });
      });
    };

    this.post = function (endpoint, data) {
      return __awaiter(_this, void 0, void 0, function () {
        var url;
        return __generator(this, function (_a) {
          url = this.baseUrl + endpoint;
          return [2
          /*return*/
          , axios_1.default.post(url + ("?api_token=" + this.token), data, headers)];
        });
      });
    };

    this.patch = function (endpoint, data) {
      return __awaiter(_this, void 0, void 0, function () {
        var url;
        return __generator(this, function (_a) {
          url = this.baseUrl + endpoint;
          return [2
          /*return*/
          , axios_1.default.patch(url + ("?api_token=" + this.token), data, headers)];
        });
      });
    };

    this.put = function (endpoint, data) {
      return __awaiter(_this, void 0, void 0, function () {
        var url;
        return __generator(this, function (_a) {
          url = this.baseUrl + endpoint;
          return [2
          /*return*/
          , axios_1.default.put(url + ("?api_token=" + this.token), data, headers)];
        });
      });
    };

    this.fetchLead = function (clientId) {
      return __awaiter(_this, void 0, void 0, function () {
        var res, _a, code, email, quiz_answers, client;

        var _b;

        return __generator(this, function (_c) {
          switch (_c.label) {
            case 0:
              return [4
              /*yield*/
              , this.get("leads/" + clientId)];

            case 1:
              res = _c.sent();
              _a = res.data.data, code = _a.code, email = _a.email, quiz_answers = _a.quiz_answers, client = _a.client;
              return [2
              /*return*/
              , __assign(__assign({
                code: code,
                email: email
              }, quiz_answers), {
                order: {
                  order_id: (_b = client === null || client === void 0 ? void 0 : client.order) === null || _b === void 0 ? void 0 : _b.id
                },
                orders: client === null || client === void 0 ? void 0 : client.orders,
                shipping_addresses: (client === null || client === void 0 ? void 0 : client.addresses) || []
              })];
          }
        });
      });
    };

    this.fetchQuiz = function (variant) {
      if (variant === void 0) {
        variant = 'main';
      }

      return __awaiter(_this, void 0, void 0, function () {
        var res;
        return __generator(this, function (_a) {
          switch (_a.label) {
            case 0:
              return [4
              /*yield*/
              , this.get("quizzes/" + variant)];

            case 1:
              res = _a.sent();
              return [2
              /*return*/
              , res.data.data];
          }
        });
      });
    };

    this.fetchProducts = function () {
      return __awaiter(_this, void 0, void 0, function () {
        var res;
        return __generator(this, function (_a) {
          switch (_a.label) {
            case 0:
              return [4
              /*yield*/
              , this.get('products')];

            case 1:
              res = _a.sent();
              return [2
              /*return*/
              , res.data.data];
          }
        });
      });
    };

    this.fetchUpsells = function (code) {
      return __awaiter(_this, void 0, void 0, function () {
        var res;
        return __generator(this, function (_a) {
          switch (_a.label) {
            case 0:
              return [4
              /*yield*/
              , this.get("upsells/" + code)];

            case 1:
              res = _a.sent();
              return [2
              /*return*/
              , {
                products: res.data.data,
                upsellUrls: res.data.upsell_urls
              }];
          }
        });
      });
    };

    this.fetchProjectConfig = function (provider) {
      return __awaiter(_this, void 0, void 0, function () {
        var paymentProvider, res;
        return __generator(this, function (_a) {
          switch (_a.label) {
            case 0:
              paymentProvider = provider ? "&gateway=" + provider : undefined;
              return [4
              /*yield*/
              , this.get("project", paymentProvider)];

            case 1:
              res = _a.sent();
              return [2
              /*return*/
              , res.data.data];
          }
        });
      });
    };

    this.createLead = function (data) {
      return __awaiter(_this, void 0, void 0, function () {
        var res;
        return __generator(this, function (_a) {
          switch (_a.label) {
            case 0:
              return [4
              /*yield*/
              , this.post("leads", data)];

            case 1:
              res = _a.sent();
              return [2
              /*return*/
              , res.data.data];
          }
        });
      });
    };

    this.updateLead = function (code, data) {
      return __awaiter(_this, void 0, void 0, function () {
        var res;
        return __generator(this, function (_a) {
          switch (_a.label) {
            case 0:
              return [4
              /*yield*/
              , this.patch("leads/" + code, data)];

            case 1:
              res = _a.sent();
              return [2
              /*return*/
              , res.data.data];
          }
        });
      });
    };

    this.createShippingInfo = function (clientId, orderId, data) {
      return __awaiter(_this, void 0, void 0, function () {
        var res;
        return __generator(this, function (_a) {
          switch (_a.label) {
            case 0:
              return [4
              /*yield*/
              , this.post("clients/" + clientId + "/orders/" + orderId + "/addresses", data)];

            case 1:
              res = _a.sent();
              return [2
              /*return*/
              , res.data];
          }
        });
      });
    };

    this.createSubscriber = function (clientId, data) {
      return __awaiter(_this, void 0, void 0, function () {
        var res;
        return __generator(this, function (_a) {
          switch (_a.label) {
            case 0:
              return [4
              /*yield*/
              , this.post("leads/" + clientId + "/subscriber", data)];

            case 1:
              res = _a.sent();
              return [2
              /*return*/
              , res.data.data];
          }
        });
      });
    };

    this.setMailerLiteData = function (clientId, data) {
      return __awaiter(_this, void 0, void 0, function () {
        var res;
        return __generator(this, function (_a) {
          switch (_a.label) {
            case 0:
              return [4
              /*yield*/
              , this.post("leads/" + clientId + "/subscriber", data)];

            case 1:
              res = _a.sent();
              return [2
              /*return*/
              , res.status];
          }
        });
      });
    };

    this.buyOneClick = function (upsellUrl) {
      return __awaiter(_this, void 0, void 0, function () {
        var res;
        return __generator(this, function (_a) {
          switch (_a.label) {
            case 0:
              return [4
              /*yield*/
              , axios_1.default.post(upsellUrl)];

            case 1:
              res = _a.sent();
              return [2
              /*return*/
              , res.data];
          }
        });
      });
    };

    this.createExternalId = function (clientId, key, value) {
      return __awaiter(_this, void 0, void 0, function () {
        var data, res;
        return __generator(this, function (_a) {
          switch (_a.label) {
            case 0:
              data = {
                key: key,
                value: value
              };
              return [4
              /*yield*/
              , this.post("leads/" + clientId + "/external_data", data)];

            case 1:
              res = _a.sent();
              return [2
              /*return*/
              , res.data.data];
          }
        });
      });
    };

    this.fetchCoupon = function (coupon) {
      return __awaiter(_this, void 0, void 0, function () {
        var res;
        return __generator(this, function (_a) {
          switch (_a.label) {
            case 0:
              return [4
              /*yield*/
              , this.get("coupons/" + coupon)];

            case 1:
              res = _a.sent();
              return [2
              /*return*/
              , res.data.data];
          }
        });
      });
    };

    this.token = token;
    this.baseUrl = baseUrl;
  }

  return RndApi;
}();

exports.RndApi = RndApi;